//npm run dev => Builds dev code
//npm run prod => Builds prod code (previously you changed production: to true)

const hubUrls = {
  innovation: 'innovationhub.stanford.edu/',
  ai: 'onlinehub.stanford.edu/',
};

const devOptions = {
  shortHubUrl: 'hubUrls.ai', //change me to the base url of your hub (no http(s) or www)
  fullHubUrl: `http://${hubUrls.ai}` + '?onbrand', //exact url to access hub, leave onbrand query string
  cihostFolder: 'scpd-multi', //change me to the cihost folder name
  remindMeToGit: true,
  notifyOnBuildSuccess: true, //Gives a (slightly annoying?) message whenever a build completes successfully
};

module.exports = devOptions;



// WEBPACK FOOTER //
// ./dev-options.js